import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useZonesBySearch(search: string, limit?: number) {
  const queryClient = useQueryClient();
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery({
    queryKey: ["zones", activeSessionId, search],

    queryFn: ({ signal }) => {
      if (search.length < 3) {
        return geotabClient.get("Zone", {}, limit ?? 1000, signal);
      }

      return geotabClient
        .get(
          "Zone",
          { keywords: search.split(" ").map(keyword => `%${keyword}%`) },
          limit ?? 1000,
          signal,
        )
        .then(zones => {
          for (const zone of zones) {
            queryClient.setQueryData(["zone", activeSessionId, zone.id], zone);
          }
          return zones;
        });
    }
  });
}
